/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TissAliases {
  ACCORDION_SITUACAO_INICIAL = 'accordion-situacao-inicial',
  FETCH_OPME = 'fetch-opme',
  FETCH_QUIMIO = 'fetch-quimio',
  FETCH_QUIMIO_CID = 'fetch-quimio-cid',
  FETCH_QUIMIO_DIAGNOSTICO = 'fetch-quimio-diagnostico',
  FETCH_RADIO = 'fetch-radio',
  FETCH_RADIO_CID = 'fetch-radio-cid',
  FETCH_RADIO_DIAGNOSTICO = 'fetch-radio-diagnostico',
  FETCH_SITUACAO_INICIAL = 'fetch-situacao-inicial',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_01 = 'field-01',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_12 = 'field-12',
  FIELD_13 = 'field-13',
  FIELD_14 = 'field-14',
  FIELD_15 = 'field-15',
  FIELD_16 = 'field-16',
  FIELD_17 = 'field-17',
  FIELD_18 = 'field-18',
  FIELD_19 = 'field-19',
  FIELD_20 = 'field-20',
  FIELD_21 = 'field-21',
  FIELD_22 = 'field-22',
  FIELD_23 = 'field-23',
  FIELD_24 = 'field-24',
  FIELD_25 = 'field-25',
  FIELD_26 = 'field-26',
  FIELD_27 = 'field-27',
  FIELD_28 = 'field-28',
  FIELD_29 = 'field-29',
  FIELD_30 = 'field-30',
  FIELD_31 = 'field-31',
  FIELD_32 = 'field-32',
  FIELD_33 = 'field-33',
  FIELD_34 = 'field-34',
  FIELD_35 = 'field-35',
  FIELD_36 = 'field-36',
  FIELD_37 = 'field-37',
  FIELD_38 = 'field-38',
  FIELD_39 = 'field-39',
  FIELD_40 = 'field-40',
  FIELD_41 = 'field-41',
  FIELD_42 = 'field-42',
  FIELD_43 = 'field-43',
  FIELD_44 = 'field-44',
  FIELD_45 = 'field-45',
  FIELD_46 = 'field-46',
  FIELD_47 = 'field-47',
  FIELD_48 = 'field-48',
  FIELD_49 = 'field-49',
  FIELD_50 = 'field-50',
  FIELD_51 = 'field-51',
  FIELD_52 = 'field-52',
  FIELD_53 = 'field-53',
  FIELD_54 = 'field-54',
  FIELD_DS_ALTERACAO_TECIDO_MOLE = 'field-dsAlteracaoTecidoMole',
  FIELD_DS_CONDICAO_CLINICA = 'field-dsCondicaoClinica',
  FIELD_DS_DENTE = 'field-dsDente',
  FIELD_DS_DOENCA_PERIODONTAL = 'field-dsDoencaPeriodontal',
  FIELD_LIST_0 = 'field-list-0',
  FIELD_LIST_1 = 'field-list-1',
  FIELD_LIST_ODONTO = 'field-list-odonto',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  FORM_2 = 'form-2',
  FORM_3 = 'form-3',
  FORM_4 = 'form-4',
  FORM_5 = 'form-5',
  FORM_6 = 'form-6',
  FORM_SITUACAO_INICIAL = 'form-situacao-inicial',
  LAYOUT_0 = 'layout-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_01 = 'panel-01',
  PANEL_OPME = 'panel-opme',
  PANEL_QUIMIO = 'panel-quimio',
  PANEL_QUIMIO_CID = 'panel-quimio-cid',
  PANEL_QUIMIO_DIAGNOSTICO = 'panel-quimio-diagnostico',
  PANEL_RADIO = 'panel-radio',
  PANEL_RADIO_CID = 'panel-radio-cid',
  PANEL_RADIO_DIAGNOSTICO = 'panel-radio-diagnostico',
  PANEL_SITUACAO_CLINICA = 'panel-situacao-clinica',
  PANEL_SITUACAO_INICIAL = 'panel-situacao-inicial',
  PANEL_SITUACAO_INICIAL_CTRL = 'panel-situacao-inicial-ctrl',
  PHONE_NUMBER_0 = 'phone-number-0',
  PHONE_NUMBER_1 = 'phone-number-1',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
  TEXT_11 = 'text-11',
  TEXT_12 = 'text-12',
  TEXT_13 = 'text-13',
  TEXT_14 = 'text-14',
  TEXT_15 = 'text-15',
  TEXT_16 = 'text-16',
  TEXT_17 = 'text-17',
  TEXT_18 = 'text-18',
  TEXT_19 = 'text-19',
  TEXT_20 = 'text-20',
  TEXT_21 = 'text-21',
  TEXT_22 = 'text-22',
  TEXT_23 = 'text-23',
  TEXT_24 = 'text-24',
  TEXT_25 = 'text-25',
  TEXT_26 = 'text-26',
  TEXT_27 = 'text-27',
  TEXT_28 = 'text-28',
  TEXT_29 = 'text-29',
  TEXT_30 = 'text-30',
  TEXT_31 = 'text-31',
  TEXT_32 = 'text-32',
  TEXT_33 = 'text-33',
  TEXT_34 = 'text-34',
  TEXT_35 = 'text-35',
  TEXT_36 = 'text-36',
  TEXT_37 = 'text-37',
  TEXT_38 = 'text-38',
  TEXT_39 = 'text-39',
  TEXT_40 = 'text-40',
  TEXT_41 = 'text-41',
  TEXT_42 = 'text-42',
  TEXT_43 = 'text-43',
  TEXT_44 = 'text-44',
  TEXT_45 = 'text-45',
  TEXT_46 = 'text-46',
  TEXT_47 = 'text-47',
  TEXT_48 = 'text-48',
  TEXT_49 = 'text-49',
  TEXT_50 = 'text-50',
  TEXT_215 = 'text-215',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_COND_CLINICA = 'text-cond-clinica',
  TEXT_DENTE = 'text-dente',
  TEXT_DS_ALTERACAO_TECIDO_MOLE = 'text-dsAlteracaoTecidoMole',
  TEXT_DS_DOENCA_PERIODONTAL = 'text-dsDoencaPeriodontal',
  TEXT_SITUACAO_INICIAL = 'text-situacao-inicial',
}
export { TissAliases };
